exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pp-bloc-state-calc{display:block!important;font-size:1rem!important;color:#6f647d!important;font-weight:600!important;text-align:center!important;margin-top:1rem!important;margin-bottom:1rem!important}", ""]);

// exports
